module.exports = __webpack_public_path__ + "img/refund-policy-ilustra.2309e923.png";